module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gp-ca0b8d6f4d7528c9d34dbfcc836600b1.svg";